import { PlayCircle } from "iconsax-reactjs";
import InputFiel from "../../commons/InputFiel"

type VideosTextSectionProps = {
  description: string;
  onDescriptionChange: (v: string) => void;
};

export default function VideoTextSection({ description, onDescriptionChange }: VideosTextSectionProps) {

  return (
    <div className="max-w-full bg-white border rounded-2xl card-shadow p-4 flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <h3 className="flex items-center gap-1 text-gray-600 font-medium text-base leading-7">
          <PlayCircle size="20" />
          متن توضیحات ویدئو
        </h3>

        <InputFiel 
          as="textarea"
          size="lg"
          value={description}
          placeholder="توضیح کوتاه درباره محتوای بنر"
          maxLength={150}
          rows={3}
          disabled={false}
          onChange={(e) => onDescriptionChange(e.target.value)}
        />

        <p className="font-semibold text-xs text-gray-400">
          حداکثر 150 کاراکتر
        </p>
      </div>
    </div>
  );
};